// Copyright 2018 The Distill Template Authors
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//      http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

export default function(dom) {

  const head = dom.querySelector('head');

  // set language to 'en'
  if (!dom.querySelector('html').getAttribute('lang')) {
    dom.querySelector('html').setAttribute('lang', 'en');
  }

  // set charset to 'utf-8'
  if (!dom.querySelector('meta[charset]')) {
    const meta = dom.createElement('meta');
    meta.setAttribute('charset', 'utf-8');
    head.appendChild(meta);
  }

  // set viewport
  if (!dom.querySelector('meta[name=viewport]')) {
    const meta = dom.createElement('meta');
    meta.setAttribute('name', 'viewport');
    meta.setAttribute('content', 'width=device-width, initial-scale=1');
    head.appendChild(meta);
  }
}
